const autocompleteModalFilterExpiredServices = {
  site: 'Sites',
  equipments: 'Tipo do Equipamento',
  equipmentGroups: 'Grupo do Equipamento',
  place: 'Local',
  area: 'Departments',
  serviceTypes: 'Tipo do Serviço',
  companies: 'Empresa Terceira',
  frequencies: 'Periodicidade',
  
};

export default autocompleteModalFilterExpiredServices;
